export default "__VITE_ASSET__cd1dc77a__"